<!-- TODO Remove if there is no use for this component -->
<template>
  <div class="col-12 d-flex justify-content-between align-items-center mb-2 p-0">
    <div class="d-flex gap-2 align-items-center">
      <img :src="require('../images/svgs/back_arrow_icon.svg')" alt="Back Arrow Icon">
      <h3 class="m-0 order-flow-title fs-26">Place Your Order</h3>
    </div>

    <div class="jersey-options w-100" style="max-width: 217px;">
      <select v-model="selectedAgeGroup" :class="{'has-value': selectedAgeGroup}" class="styled-dropdown">
        <option v-for="ageGroup in ageGroups" :key="ageGroup" :value="ageGroup">
          {{ ageGroup }}
        </option>
      </select>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <ul class="list-unstyled category-bullet p-0 gap-2 my-32 ff-mont">
        <li v-for="(ageGroup, index) in visibleAgeGroups" :key="index">
          <a :class="['bullet-link', { 'active-link': activeIndex >= index }]">
            <div class="bullet-icon">
              <img :src="require('../images/svgs/jersey_no_7_icon.svg')" alt="Jersey No 7 Icon | AgeGroup">
            </div>

            <span>{{ ageGroup }}</span>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        ageGroups: [],
        activeIndex: 0,
        selectedAgeGroup: null,
      };
    },
    props: {
      customer: {
        type: Object,
        default: () => ({}),
      },
    },
    computed: {
      visibleAgeGroups() {
        return this.ageGroups.slice(this.activeIndex, this.activeIndex + 3);
      },
    },
    watch: {
      activeIndex(newIndex) {
        this.selectedAgeGroup = this.ageGroups[newIndex];
      },
      selectedAgeGroup(newAgeGroup) {
        const newIndex = this.ageGroups.indexOf(newAgeGroup);
        if (newIndex >= 0) {
          this.activeIndex = Math.min(newIndex, this.ageGroups.length - 3);
        }
      },
    },
    mounted() {
      this.ageGroups = this.customer.age_groups.flat();
      this.selectedAgeGroup = this.ageGroups[this.activeIndex];
    },
    methods: {
      updateActiveBreadcrumb(index) {
        if (index === 2 && this.activeIndex + 3 < this.ageGroups.length) {
          this.activeIndex++;
        } else if (index === 0 && this.activeIndex > 0) {
          this.activeIndex--;
        } else {
          this.activeIndex = Math.max(0, this.activeIndex + index);
        }
      },
      updateBreadcrumbFromDropdown() {
        const newIndex = this.ageGroups.indexOf(this.selectedAgeGroup);
        this.activeIndex = Math.min(newIndex, this.ageGroups.length - 3);
      },
    },
  };
</script>
